/**
 * Login (username) yordamchilari: qoida backend bilan bir xil (apps/accounts/usernames.py) -- 3-30 belgi, kichik lotin
 * harflar, raqam, nuqta, pastki chiziq, defis. Taklif ism-familiyadan ("jasur.tursunov"); vaqtinchalik parol generatori.
 */
export const USERNAME_RE = /^[a-z0-9][a-z0-9._-]{2,29}$/;

const CYR: Record<string, string> = {
  а: "a", б: "b", в: "v", г: "g", д: "d", е: "e", ё: "yo", ж: "j", з: "z", и: "i", й: "y", к: "k", л: "l", м: "m", н: "n", о: "o",
  п: "p", р: "r", с: "s", т: "t", у: "u", ф: "f", х: "x", ц: "ts", ч: "ch", ш: "sh", щ: "sh", ъ: "", ы: "i", ь: "", э: "e", ю: "yu",
  я: "ya", ў: "o", қ: "q", ғ: "g", ҳ: "h",
};

export function normalizeUsername(raw: string): string {
  return raw.trim().toLowerCase();
}

export function isValidUsername(raw: string): boolean {
  return USERNAME_RE.test(normalizeUsername(raw));
}

/** Istalgan matndan login asosi: translit, diakritika va apostroflar tashlanadi, qolgan belgilar nuqtaga */
export function slugUsername(text: string): string {
  let s = text.toLowerCase().replace(/['ʼ‘’]/g, "");
  s = Array.from(s, (ch) => CYR[ch] ?? ch).join("");
  s = s.normalize("NFKD").replace(/[̀-ͯ]/g, "");
  s = s.replace(/[^a-z0-9]+/g, ".").replace(/^[._-]+|[._-]+$/g, "").replace(/\.{2,}/g, ".");
  return s.slice(0, 30).replace(/[._-]+$/g, "");
}

/** Ism va familiyadan: "jasur.tursunov"; juda qisqa bo'lsa "user" bilan to'ldiriladi */
export function suggestUsername(first: string, last = ""): string {
  let base = slugUsername(`${first} ${last}`.trim());
  if (base.length < 3) base = base ? `${base}.user` : "user";
  return base.slice(0, 30).replace(/[._-]+$/g, "");
}

// Adashtiradigan belgilar yo'q (0/O, 1/l/I): og'zaki yoki qog'ozda topshirishga qulay
const LETTERS = "abcdefghjkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ";
const DIGITS = "23456789";

/** Vaqtinchalik parol: 12 belgi, kamida 2 ta raqam; `random` -- test uchun (0..1 beradi) */
export function generatePassword(random: () => number = secureRandom): string {
  const pick = (set: string) => set[Math.floor(random() * set.length)];
  const chars = [pick(DIGITS), pick(DIGITS), ...Array.from({ length: 10 }, () => pick(LETTERS + DIGITS))];
  for (let i = chars.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join("");
}

function secureRandom(): number {
  const buf = new Uint32Array(1);
  crypto.getRandomValues(buf);
  return buf[0] / 2 ** 32;
}
